import queryString from "query-string";
import _ from "lodash";

/**
 * Takes string like: '-createdAt' and returns object  {sortField: 'createdAt' , sortDirection: 'desc'}
 *
 * @param {string} sort
 * @returns {object}
 */

export const parseSortParams = (sort) => {
    const isDescending = _.startsWith(sort, "-");

    return {
        sortDirection: isDescending ? "desc" : "asc",
        sortField: isDescending ? sort.slice(1) : sort,
    };
};

/**
 * Takes a query params like this "page[number]=1&page[size]=10&sort=-createdAt&filter[name]=joe"
 * to parse it and returns a structured object like this
 * { pageIndex: 1, pageNumber: 10,  searchQuery: 'name:joe', sortDirection: '-', sortField: 'createdAt'}
 * @param {string} params
 * @returns {object}
 */
export function parseTableQueryParams(params) {
    const queryParams = queryString.parse(params);
    const { sort } = queryParams;

    const result = {
        pageIndex: _.parseInt(queryParams["page[number]"]) - 1,
        pageSize: _.parseInt(queryParams["page[size]"]),
        searchQuery: queryParams["filter[q]"] || "",
        ...parseSortParams(sort),
    };

    return result;
}

/**
 * Takes params of sorting, filtering and pagination attributes like this
 * pageIndex: 1, pageNumber: 10,  searchQuery: 'name:joe', sortDirection: '-', sortField: 'createdAt'
 * to build a query param and returns is i.e
 * "page[number]=1&page[size]=10&sort=-createdAt&filter[name]=joe"
 * @param {integer} pageIndex
 * @param {integer} pageSize
 * @param {string} sortField
 * @param {string} sortDirection
 * @param {string} searchQuery
 * @returns {string} queryParam
 */
export function buildTableQueryParams(
    pageIndex,
    pageSize,
    sortField,
    sortDirection,
    searchQuery,
    entityName,
    parentMenu
) {
    const sortParam = sortDirection === "desc" ? `-${sortField}` : sortField;
    const queryParam = `/${entityName}?page[number]=${
        pageIndex + 1
    }&page[size]=${pageSize}&sort=${sortParam}${searchQuery && `&filter[q]=${searchQuery}`}`;
    if (parentMenu) {
        return `/${parentMenu}${queryParam}`;
    }
    return queryParam;
}
